import { http } from './http';

export type Product = {
  id: string;
  type: 'product';
  name: string;
};

export const fetchProducts = async () => {
  const { data } = await http.get<Product[]>('/products');

  return data;
};

export const fetchProduct = async (id: Product['id']) => {
  const { data } = await http.get<Product>(`/products/${id}`);

  return data;
};

export const fetchAddProduct = async (productName: Product['name']) => {
  const { data } = await http.post<Product>(`/products?name=${productName}`);
  return data;
};
